// Centralized data for Native Touch Group website.
// All "external" links are placeholders ("#") until real brand URLs are provided.

export const SITE = {
  name: "Native Touch Group",
  tagline: "Four Brands. One Food Ecosystem.",
  established: "Estd. 2022",
  parent: "An EBG Group Company",
  philosophy:
    "Not a compromise. A better way to eat. We make millets premium, delicious and familiar — turning conscious eating into something people actually crave.",
  contact: {
    address: "Native Touch Group, Pune, Maharashtra, India",
    phone: "+91 98220 00000",
    email: "hello@nativetouchgroup.com",
    support: "+91 98220 00111",
  },
  socials: [
    { label: "Instagram", href: "#" },
    { label: "LinkedIn", href: "#" },
    { label: "YouTube", href: "#" },
    { label: "X (Twitter)", href: "#" },
  ],
};

export const LOGOS = {
  native_touch:
    "https://customer-assets.emergentagent.com/job_e0f1523c-f8f9-4466-bc29-7928c6bd4e46/artifacts/h0v2nedz_Asset%208%404x.png",
  ebg:
    "https://customer-assets.emergentagent.com/job_millet-ecosystem/artifacts/af2fwe5e_EBG%20Logo.png",
  stories:
    "https://customer-assets.emergentagent.com/job_e0f1523c-f8f9-4466-bc29-7928c6bd4e46/artifacts/dv9ctlxn_Stories%20Logo.png",
  millet_plaza:
    "https://customer-assets.emergentagent.com/job_e0f1523c-f8f9-4466-bc29-7928c6bd4e46/artifacts/zflc7gla_Millet%20Plaza%20Logo.png",
  gomill:
    "https://customer-assets.emergentagent.com/job_e0f1523c-f8f9-4466-bc29-7928c6bd4e46/artifacts/ar66q9ca_GoMill%20Logo.png",
  promill:
    "https://customer-assets.emergentagent.com/job_e0f1523c-f8f9-4466-bc29-7928c6bd4e46/artifacts/3ordmhqp_ProMill%20Logo.png",
};

// Brands page only — premium variants (transparent PNG, larger format)
export const BRANDS_PAGE_LOGOS = {
  promill: "/images/logos/promill_logo02.png",
  gomill: "/images/logos/gomill_logo02.png",
  "millet-plaza": "/images/logos/milletplaza_logo02.png",
  stories: "/images/logos/stories_logo.png",
};

export const IMAGES = {
  heroCinematic: "/images/shared/n01.png",
  wheatField: "/images/shared/n06.png",
  promillBowl: "/images/promill/promill01.png",
  promillBowl2: "/images/promill/promill02.png",
  gomillTruck: "/images/gomill/gomill01.png",
  milletPlazaDining: "/images/millet-plaza/milletplaza01.png",
  storiesInterior: "/images/stories/stories01.png",
  packaged: "/images/shared/n02.png",
  milletGrains: "/images/shared/n03.png",
  cafeAmbience: "/images/stories/stories02.png",
  familyDining: "/images/millet-plaza/milletplaza02.png",
  noodles: "/images/shop/shop01.png",
  pasta: "/images/shop/shop02.png",
  cookies: "/images/shop/shop03.png",
  snacks: "/images/shop/shop04.png",
  readyMix: "/images/shop/shop01.png",
  staples: "/images/shop/shop02.png",
  farmer: "/images/shared/n04.png",
  kitchen: "/images/shared/n05.png",
  founder: "/images/shared/n04.png",
  milletBranch: "/images/shared/millet-branch.png",
  franchiseKitchen: "/images/shared/franchise-kitchen.png",
};

export const BRANDS = [
  {
    slug: "promill",
    name: "ProMill",
    tagline: "Performance Meals, Reinvented with Millets.",
    category: "Performance · Quick Service",
    short: "High-protein wraps, bowls, salads and smoothies built on millet bases.",
    accent: "#0F8A52",
    logo: LOGOS.promill,
    hero: IMAGES.promillBowl,
    secondary: IMAGES.promillBowl2,
    site: "#",
    story:
      "ProMill is engineered for the modern body. A protein-first millet kitchen designed for athletes, founders and everyday performers who refuse to choose between fuel and flavour.",
    pillars: [
      { label: "Millet Bases", text: "Foxtail, Jowar, Ragi & Bajra grain bowls." },
      { label: "Clean Sauces", text: "House-made, no preservatives, low sodium." },
      { label: "High Protein", text: "28g+ per meal · Paneer · Chicken · Tofu." },
      { label: "No Maida", text: "Zero refined flour. Ever." },
    ],
    gallery: [IMAGES.promillBowl, IMAGES.promillBowl2, IMAGES.milletGrains],
    nutrition: [
      ["Protein", "28g+"],
      ["Fibre", "9g"],
      ["Energy", "520 kcal"],
      ["Refined Carbs", "0g"],
    ],
  },
  {
    slug: "gomill",
    name: "GoMill",
    tagline: "Guilt-free food. On the go.",
    category: "Mobile Kiosk · Food Truck",
    short: "A nomadic millet kitchen. Real meals, real fast, wherever you are.",
    accent: "#D59A23",
    logo: LOGOS.gomill,
    hero: IMAGES.gomillTruck,
    secondary: IMAGES.milletGrains,
    site: "#",
    story:
      "GoMill takes millets to the streets — corporate parks, campuses, marathons, weddings, music festivals. A turnkey kiosk model that brings wholesome eating to every footpath of urban India.",
    pillars: [
      { label: "Mobile Kiosk", text: "Plug-and-play 8ft footprint." },
      { label: "Made Fresh Daily", text: "On-board prep · zero frozen pantry." },
      { label: "Franchise Ready", text: "Low CAPEX. High footfall economics." },
      { label: "Corporate Activations", text: "Office events · campus dining · expos." },
    ],
    gallery: [IMAGES.gomillTruck, IMAGES.milletGrains, IMAGES.packaged],
    nutrition: [
      ["Setup", "2 weeks"],
      ["Footprint", "8 × 6 ft"],
      ["Daily Covers", "150+"],
      ["Break-even", "9 months*"],
    ],
  },
  {
    slug: "millet-plaza",
    name: "Millet Plaza",
    tagline: "Family dining, reimagined.",
    category: "Casual Dining · Family Restaurant",
    short: "Wholesome millet meals crafted with tradition. Served with love.",
    accent: "#14573C",
    logo: LOGOS.millet_plaza,
    hero: IMAGES.milletPlazaDining,
    secondary: IMAGES.familyDining,
    site: "#",
    story:
      "Millet Plaza is the warm, candle-lit dining room of the ecosystem — heirloom recipes from across India, reinterpreted with millet at the centre of the plate. Where Sunday lunch becomes a memory.",
    pillars: [
      { label: "Breakfast to Dinner", text: "All-day, all-state millet menus." },
      { label: "Family Tables", text: "Sharing thalis · slow-cooked specials." },
      { label: "Millet Specials", text: "Bisi-bele, biryani, halwa — millet first." },
      { label: "Reserve a Table", text: "Weekend gatherings · celebrations." },
    ],
    gallery: [IMAGES.milletPlazaDining, IMAGES.familyDining, IMAGES.kitchen],
    nutrition: [
      ["Covers", "120 seats"],
      ["Menu Items", "75+"],
      ["Avg. Ticket", "₹650"],
      ["Cities", "Pune · Mumbai"],
    ],
  },
  {
    slug: "stories",
    name: "Stories — The Millet Cafe",
    tagline: "Ancient grains. Modern conversations.",
    category: "Specialty Cafe · Slow Living",
    short: "A cozy, premium café for coffee, millet bakes and unhurried conversations.",
    accent: "#584A2E",
    logo: LOGOS.stories,
    hero: IMAGES.storiesInterior,
    secondary: IMAGES.cafeAmbience,
    site: "#",
    story:
      "Stories is the quiet third place of the ecosystem — single-origin coffees, millet sourdoughs, slow afternoons and a community that comes to read, write, work and linger.",
    pillars: [
      { label: "Café Menu", text: "Espresso · cold brew · millet bakes." },
      { label: "Conversation Cover", text: "Reserve a corner · stay as long as you like." },
      { label: "Events & Community", text: "Book clubs · open mics · supper clubs." },
      { label: "Locally Sourced", text: "Artisanal · regional · seasonal." },
    ],
    gallery: [IMAGES.storiesInterior, IMAGES.cafeAmbience, IMAGES.milletGrains],
    nutrition: [
      ["Coffee Origins", "6 single-origin"],
      ["Bakes", "Daily fresh"],
      ["Seating", "Cozy 38 covers"],
      ["Wi-Fi", "Always on"],
    ],
  },
];

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "noodles", label: "Millet Noodles" },
  { id: "pasta", label: "Pasta" },
  { id: "cookies", label: "Cookies" },
  { id: "snacks", label: "Snacks" },
  { id: "mixes", label: "Ready Mixes" },
  { id: "staples", label: "Staples" },
];

export const PRODUCTS = [
  { id: 1, name: "Foxtail Millet Noodles", category: "noodles", image: "/images/shop/shop01.png", weight: "180g", price: "₹120", tags: ["No Maida", "High Fibre"] },
  { id: 2, name: "Ragi Hakka Noodles", category: "noodles", image: "/images/shop/shop01.png", weight: "180g", price: "₹135", tags: ["Iron-rich"] },
  { id: 3, name: "Millet Pasta — Penne", category: "pasta", image: "/images/shop/shop02.png", weight: "200g", price: "₹185", tags: ["100% Natural", "Source of Protein"] },
  { id: 4, name: "Millet Pasta — Fusilli", category: "pasta", image: "/images/shop/shop02.png", weight: "200g", price: "₹185", tags: ["High Fibre"] },
  { id: 5, name: "Jowar Choco Cookies", category: "cookies", image: "/images/shop/shop03.png", weight: "150g", price: "₹160", tags: ["Refined-sugar free"] },
  { id: 6, name: "Bajra Almond Cookies", category: "cookies", image: "/images/shop/shop03.png", weight: "150g", price: "₹175", tags: ["Slow carbs"] },
  { id: 7, name: "Roasted Millet Mix", category: "snacks", image: "/images/shop/shop04.png", weight: "200g", price: "₹140", tags: ["Tea-time"] },
  { id: 8, name: "Crispy Ragi Chips", category: "snacks", image: "/images/shop/shop04.png", weight: "100g", price: "₹95", tags: ["Air-baked"] },
  { id: 9, name: "Dosa Ready Mix", category: "mixes", image: "/images/shop/shop01.png", weight: "500g", price: "₹220", tags: ["Just add water"] },
  { id: 10, name: "Idli Ready Mix", category: "mixes", image: "/images/shop/shop01.png", weight: "500g", price: "₹210", tags: ["Steam & Serve"] },
  { id: 11, name: "Foxtail Millet — Whole", category: "staples", image: "/images/shop/shop02.png", weight: "1 kg", price: "₹240", tags: ["Single-origin"] },
  { id: 12, name: "Little Millet — Polished", category: "staples", image: "/images/shop/shop02.png", weight: "1 kg", price: "₹260", tags: ["Cleaned & sorted"] },
];

export const LOCATIONS = [
  { id: 1, brand: "Millet Plaza", format: "Dine-in", city: "Pune", address: "Koregaon Park, Lane 5, Pune", distance: "1.2 km" },
  { id: 2, brand: "Stories", format: "Cafe", city: "Pune", address: "Baner High Street, Pune", distance: "3.4 km" },
  { id: 3, brand: "ProMill", format: "QSR", city: "Pune", address: "Viman Nagar, Pune", distance: "5.6 km" },
  { id: 4, brand: "GoMill", format: "Kiosk", city: "Pune", address: "Hinjewadi Phase 1, Pune", distance: "8.2 km" },
  { id: 5, brand: "Millet Plaza", format: "Dine-in", city: "Mumbai", address: "Bandra West, Mumbai", distance: "—" },
  { id: 6, brand: "Stories", format: "Cafe", city: "Mumbai", address: "Khar Linking Road, Mumbai", distance: "—" },
  { id: 7, brand: "GoMill", format: "Kiosk", city: "Mumbai", address: "Powai Lake Promenade, Mumbai", distance: "—" },
  { id: 8, brand: "ProMill", format: "QSR", city: "Bengaluru", address: "Indiranagar, 12th Main, Bengaluru", distance: "—" },
  { id: 9, brand: "Stories", format: "Cafe", city: "Bengaluru", address: "Koramangala 5th Block, Bengaluru", distance: "—" },
  { id: 10, brand: "GoMill", format: "Kiosk", city: "Bengaluru", address: "Manyata Tech Park, Bengaluru", distance: "—" },
  { id: 11, brand: "Millet Plaza", format: "Dine-in", city: "Hyderabad", address: "Jubilee Hills, Hyderabad", distance: "—" },
  { id: 12, brand: "ProMill", format: "QSR", city: "Delhi", address: "Khan Market, New Delhi", distance: "—" },
];

export const CITIES = ["All Cities", "Pune", "Mumbai", "Bengaluru", "Hyderabad", "Delhi"];
export const BRAND_FILTERS = ["All Brands", "ProMill", "GoMill", "Millet Plaza", "Stories"];

export const STATS = [
  { value: "10M+", label: "Meals Served" },
  { value: "250+", label: "Products & Recipes" },
  { value: "5,000+", label: "Retail Touchpoints" },
  { value: "18+", label: "Years of Food Expertise" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Native Touch turned millets into the most exciting thing on my plate. The bowls at ProMill have replaced my gym shake.",
    name: "Aditi Rao",
    role: "Marathoner · Pune",
  },
  {
    quote:
      "Stories feels like the cafe a city deserves — slow, generous, with bakes you cannot stop thinking about.",
    name: "Vikram Iyer",
    role: "Architect · Bengaluru",
  },
  {
    quote:
      "Our GoMill kiosk paid back in eight months. The team's support — from menu to marketing — has been outstanding.",
    name: "Rajat Mehta",
    role: "Franchisee · Mumbai",
  },
];
